import React, {lazy, Suspense} from 'react'

const TurnToChristPageLazy = lazy(() =>
    import('./TurnToChristPage')
)

const TurnToChristPage = props => (
    <Suspense fallback={null}>
        <TurnToChristPageLazy {...props} />
    </Suspense>
)

export default TurnToChristPage
